<script>
      import { checkbox } from 'vue-strap';
      import Radio from '~componentes/Radio.vue';

      export default {
        components: { checkbox, Radio },
        props: {
          solicitacao: Object,
          carregandoTraducoes: Boolean,
          solicitacaoTraducao: Object
        },
        data() {
          return {
            configuracao: this.$storage.configuracao(),
          }
        },
        computed: {
          resumoContador: function() {
            let quantidadeCaracteres = this.solicitacaoTraducao.resumo ? 
                this.solicitacaoTraducao.resumo.length : 0;

            return 300 - quantidadeCaracteres;
          },
          labelDescricao() {
            if (parseInt(this.solicitacao.tipoSolicitacao) == 1) {
              return 'Nome do curso';
            }
            if (parseInt(this.solicitacao.tipoSolicitacao) == 2) {
              return 'Nome do evento';
            }
            return 'Descrição';
          },
          labelmensagemFinalSalvar() {
            var msg = 'Mensagem de conclusão ao salvar uma ';

            if (this.solicitacao.tipoSolicitacao == 4)
              msg += ' doação.';
            else
              msg += ' inscrição';

            return msg;
          }
        },
        methods: {
          validarDadosSolicitacao() {
            return this.$validator.validateAll();
          },
        },
        mounted() {
        }
      }
</script>

<template>
    <div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group required" :class="{'has-error': errors.has('descricao')}">
              <label class="control-label" for="documento">{{ labelDescricao }}</label>

              <input type="text"
                     class="form-control"
                     id="descricao"
                     v-model="solicitacaoTraducao.descricao"
                     data-vv-as="Descrição"
                     data-vv-name="descricao"
                     maxlength="200"
                     :disabled="carregandoTraducoes"
                     v-validate="'required'">

              <p class="text-danger" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="form-group required" :class="{'has-error': errors.has('resumo')}">
              <label class="control-label" for="resumo">
                Resumo ({{ resumoContador }})
              </label>

              <textarea class="form-control"
                        id="resumo"
                        v-model="solicitacaoTraducao.resumo"
                        data-vv-rules="required"
                        data-vv-as="resumo"
                        data-vv-name="resumo"
                        v-validate
                        :disabled="carregandoTraducoes"
                        maxlength="300">
              </textarea>

              <p class="text-danger" v-show="errors.has('resumo')">{{ errors.first('resumo') }}</p>
            </div>
          </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="control-label" for="descricao-doacao">
                        Informações doação
                    </label>

                    <textarea class="form-control"
                              id="descricao-doacao"
                              style="height: 500px;"
                              :disabled="carregandoTraducoes"
                              v-model="solicitacaoTraducao.descricaoDoacao">
                    </textarea>
                </div>
            </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label class="control-label" for="mensagemFinalSalvar">
                {{labelmensagemFinalSalvar}}
              </label>

              <textarea class="form-control"
                        id="mensagemFinalSalvar"
                        :disabled="carregandoTraducoes"
                        v-model="solicitacaoTraducao.mensagemFinalSalvar">
              </textarea>
            </div>
          </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-servico/componentes/compartilhado/FormDadosAdicionaisDoacoesTraducao.vue